import { Topic } from 'widgets/myPortfolioCapsules/topics/Topic';
import { MyPortfolioCapsulesDataStateAggregation } from 'widgets/myPortfolioCapsules/store/data/MyPortfolioCapsulesDataState';
import { TopicType } from 'widgets/myPortfolioCapsules/topics/TopicType';
import { MyPortfolioCapsulesDataItem } from 'widgets/myPortfolioCapsules/store/data/MyPortfolioCapsulesData';
import React from 'react';

export const percentAdvTopic: Topic = {
    type: TopicType.PercentAdv,
    description: 'ADV %',
    requiredPortfolioColumns: ['advPct'],
    accumulatedColumns: ['advPct'],
    weights: [],
    getSymbolValues,
    help: (
        <div>
            This topic ranks symbols by summing the ADV% of each order for that
            symbol in your portfolio. As such, you can see the impact if you
            were to execute all orders for that symbol. You can sort by
            ascending or descending and configure the number of symbols you
            would like to display.
        </div>
    ),
    deriveShouldExcludeZeros: () => true,
};

/*
 * Given aggregated data, calculates the values per symbol
 */
function getSymbolValues(
    aggregatedData: MyPortfolioCapsulesDataStateAggregation
): MyPortfolioCapsulesDataItem[] {
    return Object.keys(aggregatedData.bySymbol)
        .map((symbol) => ({
            symbol,
            symbolData: aggregatedData.bySymbol[symbol],
        }))
        .map((data) => {
            const { symbol, symbolData } = data;

            const {
                accumulated: { advPct },
            } = symbolData;

            // Value is the accumulated advPct

            return {
                symbol,
                value: advPct ?? 0,
                qty: symbolData.accumulated.qty,
                qtyTraded: symbolData.accumulated.qtyTraded,
                qtyRemaining: symbolData.accumulated.qtyRemaining,
            };
        });
}
